export default "__VITE_ASSET__DW$MlEn4__"